import { marker as TRANSLATE } from '@biesbjerg/ngx-translate-extract-marker';
import { getStatusChart } from './store';
import { isLabeledStatement } from 'typescript';

export const statusMapping = {
  0: {
    'type': 'Normal',
    'status': 'normal',
    'desc': 'The {DeviceType} is working normally.',
    'icon': 'fa-check-circle',
    'image': 'BS450-650-850E(RU)_3D_sq_photo',
    'batteryCapacity': 95
  },
  1: {
    'type': 'Warning',
    'status': 'warning',
    'desc': TRANSLATE('PPPE service is not ready.'),
    'icon': 'fa-exclamation-circle',
    'image': 'BS450-650-850E(RU)_3D_sq_photo',
    'batteryCapacity': 95
  },
  2: {
    'type': 'Critical',
    'status': 'critical',
    'desc': 'Unable to establish communication with {DeviceType}.',
    'icon': 'fa-times-circle',
    'image': 'BS450-650-850E(RU)_3D_sq_photo',
    'batteryCapacity': 95
  },
  3: {
    'type': 'Offline',
    'status': 'offline',
    'desc': 'Unable to establish communication with {DeviceType}.',
    'icon': 'fa-question-circle',
    'image': 'BS450-650-850E(RU)_3D_sq_photo',
    'batteryCapacity': 95
  },
  4: {
    'type': 'Hardware Status',
    'status': 'Hardware Fault',
    'desc': 'Unable to establish communication with {DeviceType}.',
    'icon': 'fa-question-circle',
    'image': 'BS450-650-850E(RU)_3D_sq_photo',
    'batteryCapacity': 95
  },
};

export const deviceType = {
  0: 'UPS',
  1: 'MobileDevice',
  2: 'RMC',
  3: 'SmartPlug'
};

export const DeviceSubTypeMapping = {
  'UPS': 0,
  'Inverter': 1,
  '3-Phase UPS': 2,
  'ATS': 3,
  'PDU': 4,
  'nATS': 5,
  'nPDU': 6
};

export const DeviceSubType = {
  0: {
    value: 0,
    name: 'UPS',
    displayName: 'UPS',
    displayTag: 'UPS',
    display: true,
    BHIdisplay: true,
    options: true,
    status_cols: ['timeDate', 'InVolt', 'InFreq', 'OutVolt', 'OutFreq', 'DevLoad', 'BatCap', 'BatRun', 'SysTemp', 'EnvTemp', 'EnvHumi'],
    statusPeak_cols: ['date', 'inputVolt', 'outputVolt', 'inputFreq', 'outputFreq', 'temp', 'hum'],
    status_chart: {
      voltageChart: [
        {label: 'Output Volt', data: 'outputVol', borderColor: '#dd1c1a', backgroundColor: '#dd1c1a'},
        {label: 'Input Volt', data: 'inputVol', borderColor: '#007ad9', backgroundColor: '#007ad9'}
      ],
      frequencyChart: [
        {label: 'Input Frequency', data: 'inputFreq', borderColor: '#78ac37', backgroundColor: '#78ac37'},
        {label: 'Output Frequency', data: 'outputFreq', borderColor: '#dd1c1a', backgroundColor: '#dd1c1a'}
      ],
      temperatureChart: [
        {label: 'UPS Temperature', data: 'sysTemp', borderColor: '#f57f17', backgroundColor: '#f57f17'}
      ],
      humidityChart: [
        {label: 'Humidity', data: 'envHumi', borderColor: '#ff6384', backgroundColor: '#ff6384'}
      ],
      loadChart: [
        {label: 'Load', data: 'devLoad', borderColor: '#007ad9', backgroundColor: '#007ad9'}
      ]
    }
  },
  1: {
    value: 1,
    name: 'Inverter',
    displayName: 'Inverter',
    displayTag: 'UPS',
    display: false,
    BHIdisplay: false,
    options: false,
    status_cols: ['timeDate', 'InVolt', 'InFreq', 'OutVolt', 'OutFreq', 'DevLoad', 'BatCap', 'BatRun', 'SysTemp', 'EnvTemp', 'EnvHumi'],
    statusPeak_cols: ['date', 'inputVolt', 'outputVolt', 'inputFreq', 'outputFreq', 'temp', 'hum'],
    status_chart: {
      voltageChart: [
        {label: 'Output Volt', data: 'outputVol', borderColor: '#dd1c1a', backgroundColor: '#dd1c1a'},
        {label: 'Input Volt', data: 'inputVol', borderColor: '#007ad9', backgroundColor: '#007ad9'}
      ],
      frequencyChart: [
        {label: 'Input Frequency', data: 'inputFreq', borderColor: '#78ac37', backgroundColor: '#78ac37'},
        {label: 'Output Frequency', data: 'outputFreq', borderColor: '#dd1c1a', backgroundColor: '#dd1c1a'}
      ],
      temperatureChart: [
        {label: 'UPS Temperature', data: 'sysTemp', borderColor: '#f57f17', backgroundColor: '#f57f17'}
      ],
      humidityChart: [
        {label: 'Humidity', data: 'envHumi', borderColor: '#ff6384', backgroundColor: '#ff6384'}
      ],
      loadChart: [
        {label: 'Load', data: 'devLoad', borderColor: '#007ad9', backgroundColor: '#007ad9'}
      ]
    }
  },
  2: {
    value: 2,
    name: '3-Phase UPS',
    displayName: '3-Phase UPS',
    displayTag: '3-PH UPS',
    display: true,
    BHIdisplay: false,
    options: true,
    status_cols: ['timeDate', 'BpsVoltABC', 'InVoltABC', 'OutVoltABC', 'InFreqABC', 'OutFreqABC', 'UPSLoadABC', 'BpsFreqABC'],
    statusPeak_cols: ['date', 'OutVoltA', 'OutVoltB', 'OutVoltC', 'InVoltA', 'InVoltB', 'InVoltC'],
    status_chart: {
      voltageChart: [
        // {label: 'Output Voltage', data: 'outputVol', borderColor: '#dd1c1a', backgroundColor: '#dd1c1a'},
        {label: 'Bypass Voltage-A', data: 'bpsVoltA', borderColor: '#007ad9', backgroundColor: '#007ad9'},
        {label: 'Bypass Voltage-B', data: 'bpsVoltB', borderColor: '#03a9f4', backgroundColor: '#03a9f4'},
        {label: 'Bypass Voltage-C', data: 'bpsVoltC', borderColor: '#4fc3f7', backgroundColor: '#4fc3f7'},
        {label: 'Input Voltage-A', data: 'inputVolA', borderColor: '#388e3c', backgroundColor: '#388e3c'},
        {label: 'Input Voltage-B', data: 'inputVolB', borderColor: '#78ac37', backgroundColor: '#78ac37'},
        {label: 'Input Voltage-C', data: 'inputVolC', borderColor: '#81c784', backgroundColor: '#81c784'},
        {label: 'Output Voltage-A', data: 'outputVolA', borderColor: '#d50000', backgroundColor: '#d50000'},
        {label: 'Output Voltage-B', data: 'outputVolB', borderColor: '#ff1744', backgroundColor: '#ff1744'},
        {label: 'Output Voltage-C', data: 'outputVolC', borderColor: '#ff5252', backgroundColor: '#ff5252'}
      ],
      frequencyChart: [
        {label: 'Bypass Frequency-A', data: 'bpsFreqA', borderColor: '#007ad9', backgroundColor: '#007ad9'},
        {label: 'Bypass Frequency-B', data: 'bpsFreqB', borderColor: '#03a9f4', backgroundColor: '#03a9f4'},
        {label: 'Bypass Frequency-C', data: 'bpsFreqC', borderColor: '#4fc3f7', backgroundColor: '#4fc3f7'},
        {label: 'Input Frequency-A', data: 'inputFreqA', borderColor: '#388e3c', backgroundColor: '#388e3c'},
        {label: 'Input Frequency-B', data: 'inputFreqB', borderColor: '#78ac37', backgroundColor: '#78ac37'},
        {label: 'Input Frequency-C', data: 'inputFreqC', borderColor: '#81c784', backgroundColor: '#81c784'},
        {label: 'Output Frequency-A', data: 'outputFreqA', borderColor: '#d50000', backgroundColor: '#d50000'},
        {label: 'Output Frequency-B', data: 'outputFreqB', borderColor: '#ff1744', backgroundColor: '#ff1744'},
        {label: 'Output Frequency-C', data: 'outputFreqC', borderColor: '#ff5252', backgroundColor: '#ff5252'}
      ],
      loadChart: [
        {label: 'UPS Load-A', data: 'upsLoadA', borderColor: '#007ad9', backgroundColor: '#007ad9'},
        {label: 'UPS Load-B', data: 'upsLoadB', borderColor: '#03a9f4', backgroundColor: '#03a9f4'},
        {label: 'UPS Load-C', data: 'upsLoadC', borderColor: '#4fc3f7', backgroundColor: '#4fc3f7'}
      ]
    }
  },
  3: {
    value: 3,
    name: 'ATS',
    displayName: 'ATS',
    displayTag: 'ATS',
    display: true,
    BHIdisplay: false,
    options: true,
    status_cols: ['timeDate', 'Cur', 'InVoltA', 'InVoltB', 'Power', 'Energy'],
    statusPeak_cols: ['date', 'Cur', 'InVoltA', 'InVoltB', 'Power', 'Energy'],
    status_chart: {
      currentChart: [
        {label: 'Current', data: 'current', borderColor: '#f57f17', backgroundColor: '#f57f17'},
      ],
      voltageChart: [
        {label: 'Input Voltage-A', data: 'inputVolA', borderColor: '#dd1c1a', backgroundColor: '#dd1c1a'},
        {label: 'Input Voltage-B', data: 'inputVolB', borderColor: '#007ad9', backgroundColor: '#007ad9'}
      ],
      powerChart: [
        {label: 'Power', data: 'power', borderColor: '#007ad9', backgroundColor: '#007ad9'}
      ],
      energyChart: [
        {label: 'Energy', data: 'energy', borderColor: '#78ac37', backgroundColor: '#78ac37'}
      ]
    }
  },
  4: {
    value: 4,
    name: 'PDU',
    displayName: 'PDU',
    displayTag: 'PDU',
    display: true,
    BHIdisplay: false,
    options: true,
    status_cols: ['timeDate', 'Cur', 'Volt', 'Power', 'Energy'],
    statusPeak_cols: ['date', 'Cur', 'Volt', 'Power', 'Energy'],
    status_chart: {
      currentChart: [
        {label: 'Current', data: 'current', borderColor: '#f57f17', backgroundColor: '#f57f17'}
      ],
      voltageChart: [
        {label: 'Voltage', data: 'voltage', borderColor: '#dd1c1a', backgroundColor: '#dd1c1a'}
      ],
      powerChart: [
        {label: 'Power', data: 'power', borderColor: '#007ad9', backgroundColor: '#007ad9'}
      ],
      energyChart: [
        {label: 'Energy', data: 'energy', borderColor: '#78ac37', backgroundColor: '#78ac37'}
      ]
    }
  },
  5: {
    value: 5,
    name: 'nATS',
    displayName: 'ATS',
    displayTag: 'ATS',
    display: true,
    BHIdisplay: false,
    options: false,
    status_cols: ['PowerT', 'EnergyT', 'Cur', 'PkCur', 'PkTs', 'VoltA', 'Energy', 'SrcVoltAB', 'SrcFreqAB'],
    statusPeak_cols: ['date', 'PowerT', 'EnergyT', 'Cur', 'PkCur', 'SrcVoltA', 'SrcVoltB', 'SrcFreqA', 'SrcFreqB'],
    status_chart: {
      powerChart: [
        {label: 'Power', data: 'power', borderColor: '#007ad9', backgroundColor: '#007ad9'}
      ],
      energyChart: [
        {label: 'Energy', data: 'energy', borderColor: '#78ac37', backgroundColor: '#78ac37'}
      ],
      currentChart: [
        {label: 'Current', data: 'current', borderColor: '#f57f17', backgroundColor: '#f57f17'}
      ],
      voltageChart: [
        {label: 'Source Voltage-A', data: 'srcVoltA', borderColor: '#d50000', backgroundColor: '#d50000'},
        {label: 'Source Voltage-B', data: 'srcVoltB', borderColor: '#ff1744', backgroundColor: '#ff1744'}
      ],
      frequencyChart: [
        {label: 'Source Frequency-A', data: 'srcFreqA', borderColor: '#388e3c', backgroundColor: '#388e3c'},
        {label: 'Source Frequency-B', data: 'srcFreqB', borderColor: '#78ac37', backgroundColor: '#78ac37'}
      ]
    }
  },
  6: {
    value: 6,
    name: 'nPDU',
    displayName: 'PDU',
    displayTag: 'PDU',
    display: true,
    BHIdisplay: false,
    options: false,
    status_cols: ['PowerT', 'EnergyT', 'CurABC', 'PkCur', 'PkCurABC', 'VoltABC', 'Energy'],
    statusPeak_cols: ['date', 'PowerT', 'EnergyT', 'Cur', 'PkCur', 'VoltA', 'VoltB', 'VoltC', 'Energy'],
    status_chart: {
      powerChart: [
        {label: 'Power', data: 'power', borderColor: '#007ad9', backgroundColor: '#007ad9'}
      ],
      energyChart: [
        {label: 'Energy', data: 'energy', borderColor: '#78ac37', backgroundColor: '#78ac37'}
      ],
      currentChart: [
        {label: 'Current', data: 'current', borderColor: '#f57f17', backgroundColor: '#f57f17'},
        {label: 'Current-A', data: 'currentA', borderColor: '#f9a825', backgroundColor: '#f9a825'},
        {label: 'Current-B', data: 'currentB', borderColor: '#fdd835', backgroundColor: '#fdd835'},
        {label: 'Current-C', data: 'currentC', borderColor: '#fff176', backgroundColor: '#fff176'}
      ],
      voltageChart: [
        {label: 'Voltage-A', data: 'voltA', borderColor: '#d50000', backgroundColor: '#d50000'},
        {label: 'Voltage-B', data: 'voltB', borderColor: '#ff1744', backgroundColor: '#ff1744'},
        {label: 'Voltage-C', data: 'voltC', borderColor: '#ff5252', backgroundColor: '#ff5252'}
      ]
    }
  },
};

export const SourceType = {
  'SW or Card': 0,
  'Gateway' : 1
};

export const DisplaySourceType = {
  0: {
    Type: 'Others',
    SubType: 'Others',
    DisplayTypeIndex: 0
  },
  11: {
    Type: 'Software',
    SubType: 'PowerPanel Personal',
    DisplayTypeIndex: 0
  },
  12: {
    Type: 'Software',
    SubType: 'PowerPanel Business',
    DisplayTypeIndex: 0
  },
  13: {
    Type: 'Software',
    SubType: 'PowerPanel Linux',
    DisplayTypeIndex: 1
  },
  21: {
    Type: 'Remote Cloud Card',
    SubType: 'RCCARD100',
    DisplayTypeIndex: 1
  },
  22: {
    Type: 'Remote Cloud Card',
    SubType: 'RWCCARD100',
    DisplayTypeIndex: 1
  },
  23: {
    Type: 'Remote Cloud Card',
    SubType: 'RCCARD100EMB',
    DisplayTypeIndex: 1
  },
  31: {
    Type: 'Gateway',
    SubType: 'Gateway',
    DisplayTypeIndex: 2
  }
};


export const eventMapping = {
  0: {
    'statusType': 'Warning',
    'status': 'warning',
    'desc': 'Utility power failure, battery power will be supplied.'
  },
  1: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'Utility power has been restored; the battery has stopped supplying power.'
  },
  2: {
    'statusType': 'Warning',
    'status': 'warning',
    'desc': 'Output voltage is being boosted from a lower level.'
  },
  3: {
    'statusType': 'Warning',
    'status': 'warning',
    'desc': 'Output voltage is being bucked from a higher level.'
  },
  4: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'Output voltage is normal and the voltage boost will stop.'
  },
  5: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'Output voltage is normal and the voltage buck will stop.'
  },
  6: {
    'statusType': 'Warning',
    'status': 'warning',
    'desc': 'Utility power voltage is higher than normal, battery power will be supplied.'
  },
  7: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'Utility power has been restored; the battery has stopped supplying power.'
  },
  8: {
    'statusType': 'Warning',
    'status': 'warning',
    'desc': 'Utility power voltage is lower than normal, battery power will be supplied.'
  },
  9: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'Utility power has been restored; the battery has stopped supplying power.'
  },
  16: {
    'statusType': 'Warning',
    'status': 'warning',
    'desc': 'The UPS has been turned off.'
  },
  17: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'The UPS has been turned on.'
  },
  18: {
    'statusType': 'Warning',
    'status': 'warning',
    'desc': 'The UPS entered sleep mode. Output power will not be provided.'
  },
  19: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'The UPS woke up from sleep mode. Output power is being provided.'
  },
  20: {
    'statusType': 'Warning',
    'status': 'warning',
    'desc': 'The UPS enters Bypass Mode.'
  },
  21: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'The UPS leaves Bypass Mode.'
  },
  22: {
    'statusType': 'Critical',
    'status': 'critical',
    'desc': 'The UPS bypass overload.'
  },
  24: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'Non-Critical bank has been turned on.'
  },
  25: {
    'statusType': 'Warning',
    'status': 'warning',
    'desc': 'Non-Critical bank has been turned off.'
  },
  32: {
    'statusType': 'Critical',
    'status': 'critical',
    'desc': 'The UPS has sensed an overload condition.'
  },
  34: {
    'statusType': 'Warning',
    'status': 'warning',
    'desc': 'The UPS inner temperature is too high.'
  },
  35: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'The UPS over temperature condition cleared'
  },
  36: {
    'statusType': 'Critical',
    'status': 'critical',
    'desc': 'The UPS hardware fault.'
  },
  37: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'The UPS enters ECO mode.'
  },
  38: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'The UPS leaves ECO mode.'
  },
  39: {
    'statusType': 'Critical',
    'status': 'critical',
    'desc': 'The UPS wiring fault has been detected.'
  },
  40: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'The UPS wiring fault has been cleared.'
  },
  41: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'UPS firmware starts to update.'
  },
  42: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'UPS firmware update is over.'
  },
  48: {
    'statusType': 'Warning',
    'status': 'warning',
    'desc': 'The UPS battery capacity is low than threshold, soon to be exhausted.'
  },
  49: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'The UPS has returned from a low battery condition.'
  },
  50: {
    'statusType': 'Critical',
    'status': 'critical',
    'desc': 'The battery charger is abnormal.'
  },
  51: {
    'statusType': 'Critical',
    'status': 'critical',
    'desc': 'Battery is not present.'
  },
  52: {
    'statusType': 'Critical',
    'status': 'critical',
    'desc': 'The battery may not work well anymore.'
  },
  53: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'The battery has been replaced.'
  },
  64: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'The UPS has started a battery test process.'
  },
  65: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'The UPS battery test passed.'
  },
  66: {
    'statusType': 'Critical',
    'status': 'critical',
    'desc': 'The UPS battery test failed.'
  },
  67: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'The UPS has started a runtime calibration process.'
  },
  68: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'The UPS runtime calibration completed.'
  },
  69: {
    'statusType': 'Warning',
    'status': 'warning',
    'desc': 'The UPS runtime calibration aborted.'
  },
  80: {
    'statusType': 'Critical',
    'status': 'critical',
    'desc': 'Local communication with the device has been lost.'
  },
  81: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'Communication with the device has resumed.'
  },
  82: {
    'statusType': 'Offline',
    'status': 'offline',
    'desc': 'Device is offline.'
  },
  83: {
    'statusType': 'Information',
    'status': 'normal',
    'desc': 'Device is online.'
  }
};
export const eventStatusMapping = {
  normal: {
    'icon': 'fa-check-circle'
  },
  warning: {
    'icon': 'fa-exclamation-circle'
  },
  critical: {
    'icon': 'fa-times-circle'
  },
  offline: {
    'icon': 'fa-question-circle'
  },
  'Hardware Fault': {
    'icon': 'fa-question-circle'
  }
};

export const powSourMapping = {
  0: TRANSLATE('AC Utility'),
  1: TRANSLATE('Battery'),
  2: TRANSLATE('none'),
  3: TRANSLATE('Bypass mode')
};
export const powerConditionMapping = {
  // 0: TRANSLATE('Power outage'),
  0: TRANSLATE('Power anomaly'),
  1: TRANSLATE('Under voltage'),
  2: TRANSLATE('Over voltage'),
  3: TRANSLATE('Frequency failure'),
  4: TRANSLATE('Voltage boost'),
  5: TRANSLATE('Voltage buck'),
  6: TRANSLATE('Normal')
};
export const outStaMapping = {
  0: TRANSLATE('No output'),
  1: TRANSLATE('Overload'),
  2: TRANSLATE('Voltage buck'),
  3: TRANSLATE('Voltage boost'),
  4: TRANSLATE('Bypass'),
  5: TRANSLATE('Bypass ups abnormal'),
  6: TRANSLATE('Bypass overload'),
  7: TRANSLATE('Manual bypass'),
  8: TRANSLATE('Eco mode'),
  9: TRANSLATE('Normal'),
  10: TRANSLATE('Bypass Wrong Phase Sequence'),
  11: TRANSLATE('Bypass Power Failure'),
  12: TRANSLATE('Bypass Extended Over Load'),
  13: TRANSLATE('Bypass Frequency Failure'),
  14: TRANSLATE('Bypass Fan Failure'),
  15: TRANSLATE('EPO Mode'),
  16: TRANSLATE('Insufficient Inverter Power'),
  17: TRANSLATE('Output Short Circuit'),
};
export const InStaMapping = {
  // 0: TRANSLATE('Power outage'),
  0: TRANSLATE('Power anomaly'),
  1: TRANSLATE('Under voltage'),
  2: TRANSLATE('Over voltage'),
  3: TRANSLATE('Frequency failure'),
  4: TRANSLATE('Normal'),
  5: TRANSLATE('Generator')
};
export const batStaMapping = {
  0: TRANSLATE('Fully Charged'),
  1: TRANSLATE('Charging'),
  2: TRANSLATE('Discharging'),
  3: TRANSLATE('Testing'),
  4: TRANSLATE('Not Present'),
  5: TRANSLATE('Critically Low'),
  6: TRANSLATE('Normal'),
  7: TRANSLATE('Not Work'),
  8: TRANSLATE('Boost Charging')
};
export const batHeaMapping = {
  0: TRANSLATE('Excellent'),
  1: TRANSLATE('Good'),
  2: TRANSLATE('Above Average'),
  3: TRANSLATE('Average'),
  4: TRANSLATE('Below Average'),
  5: TRANSLATE('Poor')
};
export const unitMapping = {
  0: TRANSLATE('Kilogram'),
  1: TRANSLATE('Pound')
};
export const alertMapping = {
  0: {
    'status': TRANSLATE('Information'),
  },
  1: {
    'status': TRANSLATE('Warning'),
  },
  2: {
    'status': TRANSLATE('Critical'),
  },
  3: {
    'status': TRANSLATE('Offline'),
  },
  4: {
    'status': TRANSLATE('Hardware Fault'),
  },
};
export const imageUrl = 'https://www.cyberpower.com/global/en/file/GetImageByDisplayModel/';
export const updateInfoType = {
  'FreeState': 'Free',
  'DeviceGroup': 'addDeviceGroup',
  'EditDeviceGroup': 'updateDeviceGroup',
  'EditGroup': 'updateGroup',
  'DeleteDeviceGroup': 'deleteDeviceGroup',
  'EditModule': 'updateModule',
  'EditNode': 'updateNode',
  'EditRegion': 'updateRegion',
  'AddRegion': 'addRegion',
  'DeleteRegion': 'deleteRegion',
  'GetFloorMap': 'GetFloorMap',
  'EditFloorMap': 'updateFloorMap',
  'AddFloorMap': 'addFloorMap',
  'DeleteFloorMap': 'deleteFloorMap',
  'AddLicenseMgt': 'addLicenseMgt',
  'DeleteLicenseMgt': 'deleteLicenseMgt',
  'EditLicenseMgt': 'updateLicenseMgt',
  'DeleteLicenseMgtList': 'deleteLicenseMgtList',
  'ActivateLicense': 'ActivateLicense',
  'ActivateTrialLicense': 'ActivateTrialLicense',
  'BindLicenseSN': 'BindLicenseSN',
  'DeleteDeviceSettingList': 'deleteDeviceSettingList',
  'StopLicense': 'StopLicense',
  'UpgradeFirmWare': 'UpgradeFirmWare',
  'ConfirmLicenseMgt': 'ConfirmLicenseMgt',
  'EditDeviceInfo': 'updateDeviceInfo',
  'BatteryTestFail': 'batteryTestFailed',
  'UpdateTrialLicense': 'UpdateTrialLicense',
  'AddTrialLicense': 'AddTrialLicense',
  'DeleteTrialLicense': 'DeleteTrialLicense',
  'BindMiniCard': 'BindMiniCard',
  'BindEmbCard': 'BindEmbCard',
  'BindDevice': 'BindDevice',
  'BindDeviceWithoutPack': 'BindDeviceWithoutPack',
  'GetWifiCard': 'GetWifiCard',
  'GetWifiList': 'GetWifiList',
  'GetConnectWifi': 'GetConnectWifi',
  'GetWorldMap': 'GetWorldMap',
  'AddWorldMap': 'AddWorldMap',
  'EditWorldMap': 'EditWorldMap',
  'DeleteWorldMap': 'DeleteWorldMap',
  'EditPlanMgt' : 'EditPlanMgt',
  'UpdatePlanSetting' : 'UpdatePlanSetting',
  'AddPlanList': 'AddPlanList',
  'EditPlanList': 'EditPlanList',
  'DeletePlanList': 'DeletePlanList',
  'ConfirmPlanKey': 'ConfirmPlanKey',
  'SendPlanKeyMail': 'SendPlanKeyMail',
  'ActivatePlanKey': 'ActivatePlanKey',
  'CreateOrder': 'CreateOrder',
  'AddContactUs': 'AddContactUs',
  'AddFirmwareUpload': 'AddFirmwareUpload',
  'EditFirmwareUpload': 'EditFirmwareUpload',
  'AddAzureBlobStorage': 'AddAzureBlobStorage',
  'ReleaseFirmwareUpload': 'ReleaseFirmwareUpload',
  'AddLicenseSw': 'AddLicenseSw',
  'EditLicenseSw': 'EditLicenseSw',
  'DeleteLicenseSw': 'DeleteLicenseSw',
  'ConfirmLicenseSw': 'ConfirmLicenseSw',
  'SendLicenseSwMail': 'SendLicenseSwMail',
  'AddDeviceSharingInfo': 'AddDeviceSharingInfo',
  'UpdateDeviceSharingInfo': 'UpdateDeviceSharingInfo',
  'DeleteDeviceSharingInfo': 'DeleteDeviceSharingInfo',
  'UpdateAppDownloadData' : 'UpdateAppDownloadData',
  'GoogleOAuthLogin': 'GoogleOAuthLogin',
  'FacebookOAuthLogin': 'FacebookOAuthLogin',
  'AppleOAuthLogin': 'AppleOAuthLogin',
  'AddOAuth': 'AddOAuth',
  'ReadOAuth': 'ReadOAuth',
  'UpdateOAuth': 'UpdateOAuth',
  'DeleteOAuth': 'DeleteOAuth',
  'LoginOAuth': 'LoginOAuth',
  'UpdateAccountEmail': 'UpdateAccountEmail',
  'UpdatePreference': 'UpdatePreference',
  'UpdateCompanionReceipt': 'UpdateCompanionReceipt',
  'UpdateCompanionOfflineNotify': 'UpdateCompanionOfflineNotify',
  'ReadCompanionList': 'ReadCompanionList',
  'ReadCompanionRuleList': 'ReadCompanionRuleList',
  'UpdateCompanionRule': 'UpdateCompanionRule',
  'DeleteCompanion': 'DeleteCompanion',
  'CompanionEnable': 'CompanionEnable',
  'GetCompanionsOverView': 'GetCompanionsOverView',
  'SendToApp': 'SendToApp',
  'GetCompanionProtectionProcess': 'GetCompanionProtectionProcess',
  'ConfirmCompanionProtectionProcess': 'ConfirmCompanionProtectionProcess',
  'SendKeyOfCompanionProtectionProcess': 'SendKeyOfCompanionProtectionProcess',
  'ResendDataOfCompanionProtectionProcess': 'ResendDataOfCompanionProtectionProcess',
  'StopCompanionProtectionProcess': 'StopCompanionProtectionProcess',
  'SMSSetting': 'SMSSetting',
  'DeleteMobile': 'DeleteMobile',
  'UpdateRegionMember': 'UpdateRegionMember',
  'ActivateRegionMember': 'ActivateRegionMember',
  'UpdateDeviceSetting': 'UpdateDeviceSetting',
  'ReadMspCompany': 'ReadMspCompany',
  'UpdateMspCompany': 'UpdateMspCompany',
  'AddMspCompany': 'AddMspCompany',
  'ReadMspAuthority': 'ReadMspAuthority',
  'UpdateMspAuthority': 'UpdateMspAuthority',
  'DeleteMspAuthority': 'DeleteMspAuthority',
  'AddGroupSharingInfo': 'AddGroupSharingInfo',
  'UpdateGroupSharingInfo': 'UpdateGroupSharingInfo',
  'DeleteGroupSharingInfo': 'DeleteGroupSharingInfo',
  'AddApiKey': 'AddApiKey',
  'UpdateApiKey': 'UpdateApiKey',
  'DeleteApiKey': 'DeleteApiKey',
  'ReadApiKey': 'ReadApiKey',
  'ReadApiKeyUsage': 'ReadApiKeyUsage',
  'CheckRegionMember': 'CheckRegionMember',
  'TranslateMspDevice': 'TranslateMspDevice',
  'ReadMspPaymentSetting': 'Read Msp Payment Setting',
  'ReadMspPaymentSettingByDistributor': 'Read Msp Payment Setting By Distributor',
  'UpdateMspPaymentSetting': 'Update Msp Payment Setting',
  'ReadMspPaymentDocumentList': 'Read Msp Payment Document List',
  'ReadMspPaymentDocument': 'Read Msp Payment Document',
  'UpdateMspPaymentDocument': 'Update Msp Payment Document',
  'ReadMspDeviceUsageList': 'Read Msp Device Usage List',
  'ReadMspDeviceUsage': 'Read Msp Device Usage',
  'GenerateMspPaymentDocument': 'Generate Msp Payment Document',
  'AddGateway': 'AddGateway',
  'UpdateGateway': 'UpdateGateway',
  'DeleteGateway': 'DeleteGateway',
  'UpgradeGateway': 'UpgradeGateway',
  'ReadMgtMibTrapList': 'ReadMgtMibTrapList',
  'ReadMgtMibDetail': 'ReadMgtMibDetail',
  'ReadMgtTrapDetail': 'ReadMgtTrapDetail',
  'ReadMibTrapList': 'ReadMibTrapList',
  'ReadMibDetail': 'ReadMibDetail',
  'ReadTrapDetail': 'ReadTrapDetail',
  'AddMgtMibDetail': 'AddMgtMibDetail',
  'UpdateMgtMibDetail': 'UpdateMgtMibDetail',
  'DeleteMgtMibDetail': 'DeleteMgtMibDetail',
  'AddMgtTrapDetail': 'AddMgtTrapDetail',
  'UpdateMgtTrapDetail': 'UpdateMgtTrapDetail',
  'DeleteMgtTrapDetail': 'DeleteMgtTrapDetail',
  'ReadMgtAttribute': 'ReadMgtAttribute',
  'ReadAttribute': 'ReadAttribute',
  'AddMgtAttribute': 'AddMgtAttribute',
  'UpdateMgtAttribute': 'UpdateMgtAttribute',
  'DeleteMgtAttribute': 'DeleteMgtAttribute',
  'ReadCategoryListByUser': 'ReadCategoryListByUser',
  'ReadProfileList': 'ReadProfileList',
  'ReadProfileInfo': 'ReadProfileInfo',
  'AddProfileInfo': 'AddProfileInfo',
  'UpdateProfileInfo': 'UpdateProfileInfo',
  'DeleteProfileInfo': 'DeleteProfileInfo',
  'AddDiscoveryInfo': 'AddDiscoveryInfo',
  'UpdateDiscoveryInfo': 'UpdateDiscoveryInfo',
  'DeleteDiscoveryInfo': 'DeleteDiscoveryInfo',
  'ExecutingDiscovery': 'ExecutingDiscovery',
  'StopExecutingDiscovery': 'StopExecutingDiscovery',
  'ConfirmExecutingDiscovery': 'ConfirmExecutingDiscovery',
  'AddDiscoveryResult': 'AddDiscoveryResult',
  'AddDeviceToCloud': 'AddDeviceToCloud',
  'UpdateProIncome': 'UpdateProIncome',
  'AddReportDiscount': 'AddReportDiscount',
  'UpdateReportDiscount': 'UpdateReportDiscount',
  'DeleteReportDiscount': 'DeleteReportDiscount',
  'SendProUpgradeMail': 'SendProUpgradeMail',
  'SendProPaymentDocumentMail': 'SendProPaymentDocumentMail',
  'ActivateProUpgrade': 'ActivateProUpgrade',
  'AddProPaymentPay': 'AddProPaymentPay',
  'TransferProNodes': 'TransferProNodes',
  'CheckProUpgrade': 'CheckProUpgrade',
  'UpdateSmartPowerReport': 'UpdateSmartPowerReport',
  'DeleteSmartPowerReport': 'DeleteSmartPowerReport',
  'AddMailGroup': 'AddMailGroup',
  'UpdateMailGroup': 'UpdateMailGroup',
  'DeleteMailGroup': 'DeleteMailGroup',
  'AddMailModule': 'AddMailModule',
  'UpdateMailModule': 'UpdateMailModule',
  'DeleteMailModule': 'DeleteMailModule',
  'AddBatteryTestScheduler': 'AddBatteryTestScheduler',
  'UpdateBatteryTestScheduler': 'UpdateBatteryTestScheduler',
  'DeleteBatteryTestScheduler': 'DeleteBatteryTestScheduler',
  'ExecBatteryTestScheduler': 'ExecBatteryTestScheduler',
  'UpsControlEnable': 'UpsControlEnable',
  'UpsControlDisable': 'UpsControlDisable'
};
export const groupStr = 'Group';
export const deviceStr = 'Device';
export const childDeviceStr = 'Child-Device';
export const byKeyStr = 'ByKey';
export const groupDesc = TRANSLATE('Group is working normally.');
export const timeZoneOption = [
  { label: 'Please Select:', value: null },
  { label: 'UTC-12:00 (IDLW)', value: -12 },
  { label: 'UTC-11:00 (MIT)', value: -11 },
  { label: 'UTC-10:00 (HST)', value: -10 },
  { label: 'UTC-09:00 (AKST)', value: -9 },
  { label: 'UTC-08:00 (PST/ADT)', value: -8 },
  { label: 'UTC-07:00 (MST/PDT)', value: -7 },
  { label: 'UTC-06:00 (CST/MDT)', value: -6 },
  { label: 'UTC-05:00 (EST/CDT)', value: -5 },
  { label: 'UTC-04:00 (AST/EDT)', value: -4 },
  { label: 'UTC-03:00 (SAT)', value: -3 },
  { label: 'UTC-02:00 (GST)', value: -2 },
  { label: 'UTC-01:00 (CVT)', value: -1 },
  { label: 'UTC+00:00 (GMT/WET)', value: 0 },
  { label: 'UTC+01:00 (CET)', value: 1 },
  { label: 'UTC+02:00 (EET)', value: 2 },
  { label: 'UTC+03:00 (MSK)', value: 3 },
  { label: 'UTC+04:00 (META)', value: 4 },
  { label: 'UTC+05:00 (METB)', value: 5 },
  { label: 'UTC+06:00 (BHT)', value: 6 },
  { label: 'UTC+07:00 (IST)', value: 7 },
  { label: 'UTC+08:00 (EAT/NST)', value: 8 },
  { label: 'UTC+09:00 (FET)', value: 9 },
  { label: 'UTC+10:00 (AEST)', value: 10 },
  { label: 'UTC+11:00 (VTT)', value: 11 },
  { label: 'UTC+12:00 (PSTB)', value: 12 },
  { label: 'UTC+13:00 (PSTC)', value: 13 },
  { label: 'UTC+14:00 (PSTD)', value: 14 }
];
export const moduleValueType = {
  checkbox: 'checkbox',
  number: 'number'
};
export const unitOption = [
  // { label: 'Please Select: ', value: null },
  { label: 'Kilograms', value: 0 },
  { label: 'Pound', value: 1 },
];
export const PackageList = {
  'Group': 'Group',
  'LogsExport': 'Logs Export',
  'Dashboard': 'Dashboard',
  'StatusChart': 'Status Chart',
  'EnergyInfo': 'Energy info in Device page',
  'FloorMap': 'Floor Map',
  'EventLogs': 'Event Logs',
  'StatusLogs': 'Status Logs',
  'EnergyUse': 'Energy Use',
  'AlertSetting': 'Alert Setting',
  'GroupLimit': 'Group limit',
  'FloorMapLimit': 'Floor Map limit',
  'EmailLimit': 'Email limit',
  'Licenselimit': 'License limit',
  'BatteryTest': 'Battery Test',
  'FirmwareUpdate': 'Firmware Update',
  'GlobalMap': 'Global Map',
  'SiteLimit': 'Site Limit',
  'BatteryLife': 'Recommended Battery Replacement Cycle',
  'LicenseSetting': 'License Setting',
  'DeviceAPI': 'DeviceAPI',
  'ShareDevice': 'Share Device',
  'Companion': 'Companion',
  'EventSummary': 'Event Summary',
  'AddEmail': 'Add Email'
};
export const urlPath = {
  'Dashboard': 'dashboard',
  'DeviceDetail': 'detail/:sn',
  'Floor Map': 'devicemap',
  'MapAdd': 'devicemap/add',
  'MapEdit': 'devicemap/edit/:mapId',
  'Event Logs': 'events',
  'Status Logs': 'status',
  'Energy Use': 'energy_use',
  'Alert Setting': 'alerts',
  'About': 'about',
  'Package': 'management/package',
  'AccountInfo': 'account-info',
  'PurchaseHistory': 'purchase_history',
  'OrderDetails': 'order_details/:orderno',
  'ChangeHistory': 'change_history/:dcode',
  'GroupDetail': 'group_detail/:gId',
  'ResetPwd': 'reset-password',
  'ForgetPwd': 'forget-password',
  'SignUp': 'sign-up',
  'ActivateAccount': 'activate-account',
  'Login': 'login',
  'Admin Settings': 'management/admin',
  'ProAdmin': 'management/pro/admin/:id',
  'ProUsedDeviceDetail': 'management/admin/pro/used-device-detail/:id',
  'ProUsedDeviceHistory': 'management/admin/pro/used-device-history/:hashObj',
  'AuthorityMgt': 'management/pro/account/:hashStr',
  'LicenseMgtList': 'management/license',
  'LicenseDetail': 'license-detail/:licenseId',
  'LicenseSetting': 'license-setting',
  'DeviceMgtList': 'management/device',
  'DeviceSettingDetail': 'device-detail/:dcode',
  'DeviceSetting': 'device-setting',
  'LastRunResult': 'device-setting/battery-test/result/:hashStr',
  'CardVersion': 'card-version/:cardDcode',
  'PrivacyAndTerms': 'management/privacy-and-terms/:regionId',
  'AccountManagement': 'management/account',
  'PrivacyPolicy': 'privacy-policy',
  'TermsAndConditions': 'terms-and-conditions',
  'EventMonitoring': 'monitoring/event',
  'DeviceMonitoringList': 'monitoring/device',
  'DeviceMonitoringDetail': 'monitoring/device/detail/:sn',
  'DeviceMonitoringStatus': 'monitoring/device/status/:hashStr',
  'HelpDashboard': 'help/dashboard',
  'HelpGlobalMap': 'help/globalmap',
  'HelpDeviceMap': 'help/devicemap',
  'HelpEventLog': 'help/event',
  'HelpStatusLog': 'help/status',
  'HelpAlertSetting': 'help/alert',
  'HelpLicenseSetting': 'help/license-setting',
  'HelpDeviceSetting': 'help/device-setting',
  'HelpPurchaseHistory': 'help/purchase-history',
  'HelpPlanSetting': 'help/plan-setting',
  'HelpPurchasePlan': 'help/purchase-plan',
  'HelpSystemLog': 'help/system-log',
  'ResendActivationMail': 'resend-activation-mail',
  'AccountDetail': 'management/account/account-detail/:Acode',
  'Global Map': 'globalmap',
  'PlanSetting': 'plan-setting',
  'GatewaySetting': 'gateway-setting',
  'GatewayAdvancedSetting': 'gateway-setting/advanced',
  'GatewayVersion': 'gateway-setting/gateway-version/:hashId',
  'GatewayAdmin': 'management/gateway',
  'gatewayMibDetail': 'management/gateway/mib-detail/:hashId',
  'gatewayTrapDetail': 'management/gateway/trap-detail/:hashId',
  'PlanManagement': 'management/plan',
  'AddDeviceWifi': 'add-device/:language/:hashOtp',
  'AddDeviceLogin': 'login/add-device',
  'PurchasePlan': 'purchase',
  'mobilePurchasePlan': 'mobile-purchase',
  'mobilePurchasePlanParam': 'mobile-purchase/:purchaseKey',
  'FirmwareMgt': 'management/firmware',
  'FirmwareRMCMgt': 'management/firmware/rmc',
  'UserActivityMgt': 'management/admin/user-activity',
  'Event Summary': 'event-summary',
  'HelpEventSummary': 'help/event-summary',
  'CustmizeDomain': [
    '/', '/dashboard', '/index'
  ],
  'MacSnMgt': 'management/device/reset',
  'Systemlog': 'systemlog',
  'Companion': 'companion',
  'ConfirmCompanion': 'companion/confirm/:Hash',
  'SWSocialLogin': 'login/social/sw',
  'SSOLogin': 'login/sso',
  'SSOLoginCallback': 'login/sso/callback',
  'APIDetail': 'account-info/api-detail/:apikeyid',
  'APIManagement': 'management/api',
  'APIManagementDetail': 'management/api/api-detail/:apikeyid',
  'HelpPro': 'help/pro',
  'HelpSmartPowerReport': 'help/smart-power-report',
  'DeviceTransfer': 'management/device/device-transfer',
  'ApiDocument': 'document/api',
  'OpenAPI': 'document/openapi',
  'PaymentMgt': 'management/payment',
  'PaymentDocumentInfo': 'management/payment/document/:id',
  'PaymentDocumentDetail': 'management/payment/document-detail/:id',
  'GenerateDocumentManually': 'management/payment/generate-document-manually/:id',
  'ApiTermsofuse': 'terms-of-use/api',
  'ProManagementOverview': 'management/pro/overview',
  'ProManagementCompany': 'management/pro/company',
  'ProEventMonitoring': 'pro/monitoring/event',
  'ProEventMonitoringById': 'pro/monitoring/event/:hashStr',
  'ProManagementAccount': 'management/pro/account',
  'ProDeviceManagement': 'management/pro/device',
  'ProDeviceManagementByObj': 'management/pro/device/:hashObj',
  'HelpGatewaySettings': 'help/gateway-setting',
  'ProUpgrade': 'pro/upgrade',
  'SmartPowerReportList': 'smart-power-report',
  'SmartPowerReport': 'smart-power-report/report/:hashStr',
  'SmartPowerReportDetail': 'smart-power-report/report/detail/:hashStr',
  'SmartPowerReportListManagement': 'management/smart-power-report/:hashStr',
  'SmartPowerReportManagement': 'management/smart-power-report/report/:hashStr',
  'SmartPowerReportDetailManagement': 'management/smart-power-report/report/detail/:hashStr',
};
export const addDeviceByCard = {
  0: {
    severity: 'warn',
    // tslint:disable-next-line:max-line-length
    summary: 'Add Card successfully.  \r\nPlease  note that the device will  only show on the dashboard after the Card is connected with UPS and Internet.'
  },
  1: {
    severity: 'success',
    summary: 'Add device successfully.'
  },
  2: {
    severity: 'error',
    summary: 'RMC already in your account.'
  },
  3: {
    severity: 'error',
    summary: 'Card MAC or Key is wrong! \r\nFailed to add device.'
  }
};
export const errMsgForExceedLimit = {
  'GroupLimit': {
    '0': TRANSLATE('You have reached the group number limit.')
  },
  'FloorMapLimit': {
    '0': TRANSLATE('You have reached the device map limit.')
  },
  'EmailLimit': {
    '0': TRANSLATE('You have reached the email number limit.')
  },
  'GlobalMapLimit': {
    '0': TRANSLATE('You have reached the global map limit.')
  },
};
export const changeLevelRules = {
  '1to2': 0.6,
  '2to3': 0.7,
  '1to3': 0.6 * 0.7,
  '3to2': 1.4,
  '2to1': 1.6,
  '3to1': 1.4 * 1.6
};
export const licenseMap = {
  LicenseType: {
    0: 'License',
    1: 'App Store',
    2: 'Card',
    3: 'Trial',
    4: 'Plan'
  },
  UsingStatus: {
    0: 'Open',
    1: 'Available',
    2: 'Available',
    3: 'Using',
    4: 'Waiting',
    5: 'Occupied',
    6: 'Expired'
  },
  BindType: {
    0: 'UPS',
    1: 'Card',
    2: 'SW'
  },
  CheckErrorMsg: {
    0: TRANSLATE('This license is not correct.'), // Error
    // tslint:disable-next-line:max-line-length
    2: TRANSLATE('This license has been used already. If you have any question, please contact our support team.'), // Other account has already added.
    1: TRANSLATE('This license has been added already.'), // It's already in the account.
    3: TRANSLATE('Sorry, this license must be used in device with Remote Management Card.'), // Not connect with rm card.
    4: TRANSLATE('Sorry, this device already has the card license.'),
  }
};

export const deviceTypeCodeMap = {
  0: 'UPS',
  1: 'Mobile Device',
  // 2: 'Mini Card',,
  2: 'RCCARD100',
  3: 'Smart Plug',
  // 4: 'RM Card',,
  4: 'RMCARD205',
  // 5: 'Wifi Card',
  5: 'RWCCARD100',
  6: 'RCCARD100EMB'
};
export const firmWareStatusMap = {
  0: 'Updating',
  1: 'Success',
  2: 'Failed'
};
export const authorityLevelMap = {
  0: 'EndUser',
  1: 'Admin',
  2: 'SystemAdmin',
};

export const purchaseOrderMap = {
  ItemType: {
    0: 'License',
    1: 'Package',
    2: 'Plan',
  }
};

export const PackageLevel = {
  AdvancedStr: 'Advanced',
  StandardStr: 'Standard',
  Premium: 'Premium',
  Superb: 'Superb'
};

export const purchaseModuleMap = {
  'Group limit': TRANSLATE('Group'),
  'Email limit': TRANSLATE('Email Recipient'),
  'Node Limit': TRANSLATE('Device'),
  'Floor Map': TRANSLATE('Device Map'),
  'Firmware Update': TRANSLATE('Card Firmware Update')
};

export const batteryTestStatus = {
  0: TRANSLATE('Passed'),
  1: TRANSLATE('Waiting'),
  2: TRANSLATE('Failed'),
  3: '--'
};

export const trialLicenseCategoryMap = {
  0: 'UPS',
  1: 'Card'
};

export const trialLicenseRuleMap = {
  0: 'Start With',
  1: 'End With',
  2: 'Specific',
  3: 'Middle',
  4: 'Any'
};

export const oldErrorCode = 'oldCode';

export const ERROR_CODE_Str = 'ERROR_CODE_';

export const EventNumber_Str = 'EventNumber_';

export const ReSentActivationMailMsg = {
  0: TRANSLATE('Successfully resent activation mail.'),
  1: TRANSLATE('Action failed.'),
  2: TRANSLATE('This account is already activated.')
};

export const LangList = [
  { label: 'English', value: 'en' }, { label: 'Deutsch', value: 'de' },
  { label: '繁體中文', value: 'zh' }, { label: '日本語', value: 'jp' },
  { label: '简体中文', value: 'ch' }, { label: 'Pусский', value: 'ru' },
  { label: 'Français', value: 'fr' }];

export const platformTypeMap = {
  0: 'iOS',
  1: 'Android',
  2: 'Plan Key',
  3: 'Website'
};

export const planStatusMap = {
  0: 'Available',
  1: 'Using',
  2: 'Expired'
};

export const planMailRecipientType = {
  0: 'Main Recipient',
  1: 'CC',
  2: 'BCC'
};

export const planMailRecipientTypeName = {
  'MainRecipient': 0,
  'CC': 1,
  'BCC': 2
};

export const authorityMap = {
  'EndUser': 0,
  'Admin': 1,
  'SystemAdmin': 2,
  'SalesAdmin': 3
};

export const  planChargeInfo = {
  'level_1N': {
    name: 'Level 1N',
    oneYearPrice: 11.99,
    twoYearPrice: 21.99,
    threeYearPrice: 28.99,
    level: 12,
    Grade: 100
  },
  'level_3N': {
    name: 'Level 3N',
    oneYearPrice: 35.99,
    twoYearPrice: 64.99,
    threeYearPrice: 86.99,
    level: 10,
    Grade: 100
  },
  'level_10N': {
    name: 'Level 10N',
    oneYearPrice: 119.99,
    twoYearPrice: 215.99,
    threeYearPrice: 287.99,
    level: 15,
    Grade: 100
  },
  'level_20N': {
    name: 'Level 20N',
    oneYearPrice: 309.99,
    twoYearPrice: 557.99,
    threeYearPrice: 743.99,
    level: 20,
    Grade: 200
  },
  'level_50N': {
    name: 'Level 50N',
    oneYearPrice: 779.99,
    twoYearPrice: 1403.99,
    threeYearPrice: 1871.99,
    level: 25,
    Grade: 250
  },
  'level_100N': {
    name: 'Level 100N',
    oneYearPrice: 1999.99,
    twoYearPrice: 3599.99,
    threeYearPrice: 4799.99,
    level: 30,
    Grade: 300
  },
  'level_3A': {
    name: 'Level 3A',
    oneYearPrice: 9999.99,
    twoYearPrice: 17999.99,
    threeYearPrice: 23999.99,
    level: 41,
    Grade: 400
  },
  'level_200N': {
    name: 'Level 200N',
    oneYearPrice: 3999.99,
    twoYearPrice: 7199.99,
    threeYearPrice: 9599.99,
    level: 40,
    Grade: 400
  },
  'level_5': {
    name: 'Level 5',
    oneYearPrice: 19999.99,
    level: 45,
    Grade: 400
  }
};

export const ActivateTrialLicenseMsgType = {
  0: 'Finish',
  1: 'ErrorOccured',
  2: 'DeviceCannotTrial',
  3: 'TrialLicenseNotFound',
  4: 'UpsSnNotFound'
};

export const NotificationMsgType = {
  0: {
    title: TRANSLATE('Plan Setting is not saved yet'),
    description: TRANSLATE('Plan Setting is required before users can access Devices on Cloud'),
    routeLink: '/plan-setting',
    icon: 'fa-exclamation-triangle'
  },
  1: {
    title: TRANSLATE('RBRD is expired'),
    description: TRANSLATE('Replacing current battery is recommended'),
    routeLink: '/detail/{deviceName}',
    icon: 'fa-bell'
  },
  2: {
    title: TRANSLATE('Battery health is {BHIStatus}'),
    description: TRANSLATE('Estimated score: {BHI}'),
    routeLink: '/detail/{deviceName}',
    icon: 'fa-battery-full'
  },
  3: {
    title: TRANSLATE('Trial is going to expire (day): {expiredDay}'),
    description: '',
    routeLink: '/purchase',
    icon: 'fa-lock'
  },
  4: {
    title: TRANSLATE('Your Plan {level} is going to expire (day): {expiredDay}'),
    description: '',
    routeLink: '/purchase',
    icon: 'fa-exclamation-triangle'
  },
  5: {
    title: TRANSLATE('Critical firmware update is recommended'),
    description: 'Click here to check details',
    routeLink: '/device-setting',
    icon: 'fa-bell'
  },
  6: {
    title: TRANSLATE('The device discovery process has been completed.'),
    description: '',
    routeLink: '/gateway-setting',
    icon: 'fa-bell'
  },
  7: {
    title: TRANSLATE('The discovery process of Discovery Job ({DiscoveryJobName}) has been abnormally aborted.'),
    description: '',
    routeLink: '/gateway-setting',
    icon: 'fa-bell'
  },
  8: {
    title: TRANSLATE('Gateway ({GatewayName}) update process is complete.'),
    description: '',
    routeLink: '/gateway-setting/advanced',
    icon: 'fa-bell'
  },
  9: {
    title: TRANSLATE('An error occurred during the Gateway ({GatewayName}) update process.'),
    description: '',
    routeLink: '/gateway-setting/advanced',
    icon: 'fa-bell'
  }
};

export const deviceTypeCode = [
  { label: 'RWCCARD100-US', value: 0, DeviceType: 5, regionId: 0 },
  { label: 'RWCCARD100-EU', value: 1, DeviceType: 5, regionId: 1 },
  { label: 'RCCARD100', value: 2, DeviceType: 2 },
  { label: 'RCCARD100EMB', value: 3, DeviceType: 6 },
  { label: 'PCMCARD-W', value: 4, DeviceType: 7, regionId: 1 },
  { label: 'RWCCARD101', value: 4, DeviceType: 5 }
];

export const deviceTypeCodeRMC = [
  { label: 'RMCARD205', value: 0, DeviceType: 1 },
  { label: 'RMCARD400', value: 1, DeviceType: 2 },
  { label: 'Intelligent PDU/ATS', value: 2, DeviceType: 3 },
  { label: '3phase PDU ', value: 3, DeviceType: 4 },
  { label: 'Gigabit PDU/ATS ', value: 4, DeviceType: 5 },
  { label: 'Gigabit 3PH PDU ', value: 5, DeviceType: 6 },
  { label: 'Compact PDU ', value: 6, DeviceType: 7 },
];

export const deviceTypeCodeRMCWithFile_dct = [ 1, 3, 4 ];


// export const deviceSettingTypeCode = [
//   { label: 'RMCARD205', value: 0, DeviceType: 4, regionId: 0 },
//   { label: 'RWCCARD100', value: 1, DeviceType: 5, regionId: 1 },
//   { label: 'RCCARD100', value: 2, DeviceType: 2 },
//   { label: 'RCCARD100EMB ', value: 3, DeviceType: 6 }
// ];

export const shareDeviceStatus = {
  'Waiting': 0,
  'Accepted': 1,
  'Rejected': 2
};

export const shareDeviceStatusType = {
  0: 'Waiting',
  1: 'Accepted',
  2: 'Rejected'
};

export const shareObjectType = {
  'ShareDevice': 0,
  'ShareGroupDevice': 1
};

export const monthMap = {
  1: 'Jan',
  2: 'Feb',
  3: 'Mar',
  4: 'Apr',
  5: 'May',
  6: 'Jun',
  7: 'Jul',
  8: 'Aug',
  9: 'Sep',
  10: 'Oct',
  11: 'Nov',
  12: 'Dec'
};

export const reportDataMonthlyType = {
  'active_device': 0,
  'licensed_device': 1,
  'new_connected_device': 2,
  'order': 3,
  'revenue': 4,
  'connected_device': 5,
  'api_calls': 6,
  'pro_order': 7,
  'pro_revenue': 8,
  'plan_fee': 9,
  'pro_fee': 10,
  'server_fee': 11,
  'account': 12,
  'pro_company': 13
};

// reportDataMonthlySubType 內容由API定義
export const reportDataMonthlySubType = {
  'total': 0,
  'plan': 1,
  'trial': 2,
  'card': 3,
  'sw': 4,
  'plan_lv1': 5, // deprecated
  'plan_lv2': 6, // deprecated
  'plan_lv3': 7, // deprecated
  'plan_revenue': 8,
  'wifi': 9,
  'mini': 10,
  'in_app_purchase': 11,
  'web_purchase': 12,
  'ppc_license_generator': 13,
  'plan_lv2_plus': 14, // deprecated
  'plan_lv4': 15, // deprecated
  'EMBMini': 20,
  'plan_lv3a': 21, // deprecated
  'plan_mgt': 22, // 資料by PlanMgt Id分類
  'Inverter': 23,
  'plan_discount': 24,
  'pro_income': 25, // 資料by PlanMgt Id分類
  'addition': 26,
  'losses': 27,
  'gateway': 28,
  '14days_ppc': 29,
  '14days_pro': 30,
  'pro_discount': 31,
  'renewal_rate': 32,
  'transfer_rate': 33,
  'trial_activation_rate': 34,
  'conversion_rate': 35
};

export const reportDataMonthlyTertiaryType = {
  'sw_type': 0,
  'gateway_category_type': 1,
  'report_custom_type': 2,
  'renewal_rate_range_type': 3,
  'charge_type': 4,
  'PlanMgtId': 5
};

export const reportDataMonthlySWType = {
  'PPP': 0,
  'PPB': 1,
  'PPL': 2,
  'PPG': 3
}

export const reportDataMonthlyGatewayCategoryType = {
  'UPS': 0,
  '3PhaseUPS': 1,
  'ATS': 2,
  'PDU': 3,
  'ePDU2': 4
}

export const reportDataMonthlyReportCustomType = {
  '3rdparty_devices': 0,
  'other': 1,
  'deferred': 2,
  'usage': 3,
  'remaining': 4
}

export const reportDataMonthlyRenewalRateRangeType = {
  'all': 0,
  '1-3_devices': 1,
  '4-20_devices': 2,
  'over20_devices': 3,
  'monthly': 4
}

export const reportDataMonthlyChargeType = {
  'Prepaid': 0,
  'Monthly': 1
}

export const reportDataPeriod = {
  1: 365,
  2: 730,
  3: 1095,
};
export const appDownloadType = {
  'iOS': 0,
  'Android': 1
};
export const reportTitleField = {
  'DeviceAnalysis': 'Device Analysis',
  'GrossProfitAnalysisDeferred': 'Gross Profit Analysis (Deferred Calculation)',
  'GrossProfitAnalysisRevenue': 'Gross Profit Analysis (Monthly Sales Revenue)',
  'MonthlyPurchaseAnalysis': 'Monthly Purchase Analysis',
  'MonthlyPurchaseOrderPRO': 'Monthly Purchase Order (PRO)'
};
export const reportDataField = {
  'ActiveDevice': 'Active Device (14 Days)',
  'ActiveDeviceMOM': 'Active Device (14 Days) MoM',
  'ActiveDeviceLosses': 'Active Device Losses',
  'ActiveDeviceAddition': 'Active Device Addition',
  'ActiveDeviceLossAddition': 'Active Device Loss/Addition',
  'TrialActivationRate': 'Trial Activation Rate',
  'LicensedDevice': 'Licensed Device',
  'LicensedDeviceMOM': 'Licensed Device MoM',
  'TrialLicensedDevice': 'Trial Licensed Device',
  'TrialLicensedDeviceMOM': 'Trial Licensed Device MoM',
  'LicensedDevicePCT': 'Licensed Device (%)',
  'ActiveDevice14day_PPC': 'Active Device 14-day (PPC)',
  'ActiveDevice14day_PRO': 'Active Device 14-day (PRO)',
  'NewConnected': 'New Connected',
  'NewConnectedMoM': 'New Connected MoM',
  'RCCARD100': 'RCCARD100',
  'RWCCARD100': 'RWCCARD100',
  'CloudUPS': 'CloudUPS',
  'Card': 'Card',
  'Software': 'Software',
  'PowerPanelPersonal': 'PowerPanelPersonal',
  'PowerPanelBusiness': 'PowerPanelBusiness',
  'SoftwareOthers': 'Software Others',
  'Gateway': 'Gateway',
  'GatewayUPS': 'UPS',
  'GatewayPDU': 'PDU',
  'GatewayATS': 'ATS',
  'Gateway3phaseUPS': '3-phase UPS',
  'Gateway3PartyDevices': '3-Party Devices',
  'iOS': 'iOS',
  'Android': 'Android',
  'iOSAndroid': 'iOS+Android',
  'Order': 'Order',
  'Level1N': 'Level 1N',
  'Level3N': 'Level 3N',
  'Level10N': 'Level 10N',
  'Level20N': 'Level 20N',
  'Level50N': 'Level 50N',
  'Level100N': 'Level 100N',
  'Level3A': 'Level 3A',
  'Level500N': 'Level 500N',
  'Level5': 'Level 5',
  'Level1000N': 'Level 1000N',
  'Level200N': 'Level 200N',
  'Amount': 'Amount',
  'MOM': 'MoM',
  'MOMPCT': 'MoM (%)',
  'OrderMOM': 'Order MoM',
  'OrderMOMPCT': 'Order MoM (%)',
  'AmountofPPCGenerator': 'Amount of PPC Generator',
  'AmountTotal': 'Amount Total',
  'AmountOfPPCPro': 'Amount of PPC PRO',
  'AmountTotalDiscount': 'Total Discount',
  'AmountMOM': 'Amount MoM',
  'AmountMOMPCT': 'Amount MoM (%)',
  'AccumulatedDevices': 'Accumulated Devices',
  'AccumulatedDownload': 'Accumulated Download',
  'Total': 'Total',
  'InAppPurchase': 'In-App Purchase',
  'WebPurchase': 'Web Purchase',
  'PPCLicenseGenerator': 'PPC License Generator',
  'AccumulatedOrder': 'Accumulated Order',
  'AccumulatedAmount': 'Accumulated Amount',
  'Level1N_1': 'Level1N-1',
  'Level1N_2': 'Level1N-2',
  'Level1N_3': 'Level1N-3',
  'Level3N_1': 'Level3N-1',
  'Level3N_2': 'Level3N-2',
  'Level3N_3': 'Level3N-3',
  'Level10N_1': 'Level10N-1',
  'Level10N_2': 'Level10N-2',
  'Level10N_3': 'Level10N-3',
  'Level20N_1': 'Level20N-1',
  'Level20N_2': 'Level20N-2',
  'Level20N_3': 'Level20N-3',
  'Level50N_1': 'Level50N-1',
  'Level50N_2': 'Level50N-2',
  'Level50N_3': 'Level50N-3',
  'Level100N_1': 'Level100N-1',
  'Level100N_2': 'Level100N-2',
  'Level100N_3': 'Level100N-3',
  'Level3A_1': 'Level3A-1',
  'Level3A_2': 'Level3A-2',
  'Level3A_3': 'Level3A-3',
  'Level500N_1': 'Level500N-1',
  'Level500N_2': 'Level500N-2',
  'Level500N_3': 'Level500N-3',
  'Level200N_1': 'Level200N-1',
  'Level200N_2': 'Level200N-2',
  'Level200N_3': 'Level200N-3',
  'Level5_1': 'Level5-1',
  'Level1000N_1': 'Level1000N-1',
  'TotalOrder': 'Total Order',
  'TotalDiscount': 'Total Discount',
  'TotalAmount': 'Total Amount',
  'TotalPPCPro': 'PPC PRO',
  'GPAMonthlySalesIncome': 'Monthly Sales Income',
  'GPAYearlyPlanPayPal': 'Yearly Plan (PayPal)',
  'GPAYearlyPlanAPP': 'Yearly Plan (APP)',
  'GPAYearlyPlanPPCGenerator': 'Yearly Plan (PPC Generator)',
  'GPAPPCPROPayPal': 'PPC PRO (PayPal)',
  'GPAPPCPROGenerator': 'PPC PRO (Generator)',
  'GPAPPCPRO': 'PPC PRO',
  'GPATotalCost': 'Total Cost',
  'GPAYearlyPlanPayPalFee': 'Yearly Plan (PayPal Fee)',
  'GPAYearlyPlanAPPFee': 'Yearly Plan (APP Fee)',
  'GPAYearlyPlanDiscount': 'Yearly Plan (Discount)',
  'GPAPPCPROPayPalFee': 'PPC PRO (PayPal Fee)',
  'GPARevenuePPCPRODiscount': 'PPC PRO (Discount)',
  'GPAServerFee': 'Server Fee',
  'GPAGrossProfit': 'Gross Profit',
  'GPAGrossProfitMoM': 'Gross Profit MoM',
  'GPAGrossProfitMargin': 'Gross Profit Margin',
  'GPAGrossProfitMarginMoM': 'Gross Profit Margin MoM',
  'GPADeferredMonthlySalesIncome': 'Monthly Sales Income',
  'GPADeferredYearlyPlanPayPal': 'Yearly Plan (PayPal)',
  'GPADeferredYearlyPlanAPP': 'Yearly Plan (APP)',
  'GPADeferredYearlyPlanPPCGenerator': 'Yearly Plan (PPC Generator)',
  'GPADeferredPPCPRO': 'PPC PRO',
  // 'DeferredPPCPROGenerator': 'PPC PRO (Generator)',
  'GPADeferredTotalCost': 'Total Cost',
  'GPADeferredYearlyPlanPayPalFee': 'Yearly Plan (PayPal Fee)',
  'GPADeferredYearlyPlanAppFee': 'Yearly Plan (APP Fee)',
  'GPADeferredYearlyPlanDiscount': 'Yearly Plan (Discount)',
  'GPADeferredPPCPROPayPalFee': 'PPC PRO (PayPal Fee)',
  'GPADeferredPPCPRODiscount': 'PPC PRO (Discount)',
  'GPADeferredServerFee': 'Server Fee',
  'GPADeferredGrossProfit': 'Gross Profit',
  'GPADeferredGrossProfitMoM': 'Gross Profit MoM',
  'GPADeferredGrossProfitMargin': 'Gross Profit Margin',
  'GPADeferredGrossProfitMarginMoM': 'Gross Profit Margin MoM',
  'PAYearlyPlanPurchase': 'Yearly Plan Purchase',
  'PAYearlyPlanPurchaseMoM': 'Yearly Plan Purchase MoM',
  'MonthlyRenewalRate': 'Monthly Renewal Rate',
  'PATotalPlanRenewalRate': 'Total Plan Renewal Rate',
  'PAPlanRenewalRate_1to3': '(1-3 devices)',
  'PAPlanRenewalRate_4to20': '(4-20 devices)',
  'PAPlanRenewalRate_GT20': '(>20 devices)',
  'PAPlanTransferRate': 'Plan Transfer Rate',
  'PAConversionRate': 'Conversion Rate',
  'PPCPROAccount':'PPC PRO Account',
  'NPMUsage':'NPM Usage',
  'TotalCompanyNumber':'Total Company Number',
  'NPMUsageMoM':'NPM Usage MoM',
  'TotalNPMRemaining':'Total NPM Remaining',
  'NPMPurchasedQuantityPrepaid':'NPM Purchased Quantity (Prepaid)',
  'NPMPurchasedQuantityMonthly':'NPM Purchase Quantity (Monthly)',
  'TotalNPMPurchased':'Total NPM Purchased',
  'NPMPurchaseQuantityMoM':'NPM Purchase Quantity MoM',
  'PPCPROIncome':'PPC PRO Income',
  'PPCPRODiscount':'PPC PRO Discount',
  'PPCPROTotal':'PPC PRO Total',
  'DailyActiveAccount':'Active Account',
  'DailyAccountDailyLoginRate':'Account Daily login Rate',
  'Daily1stDeviceAddUser':'1st Device add user',
  'DailyUserRetentionRate_7':'User Retention Rate (7 days)',
  'DailyUserRetentionRate_30':'User Retention Rate (30 days)',
  'DailyOpenEmailRate':'Open Email Rate (Report)',
  'DailyDailyEventNumber':'Daily Event Number',
  'DailyAverageDeviceUptime':'Average Device uptime (min)',
  'SubDevices_Level1N': 'Level 1N',
  'SubDevices_Level3N': 'Level 3N',
  'SubDevices_Level10N': 'Level 10N',
  'SubDevices_Level20N': 'Level 20N',
  'SubDevices_Level50N': 'Level 50N',
  'SubDevices_Level100N': 'Level 100N',
  'SubDevices_Level200N': 'Level 200N',
  'SubDevices_Level500N': 'Level 500N',
  'SubDevices_Pro': 'Pro',
  'SubDevices_Trial': 'Trial',
  'SubDevices_Rate': 'Subscription Devices Rate',
  'SubAccounts_Level1N': 'Level 1N',
  'SubAccounts_Level3N': 'Level 3N',
  'SubAccounts_Level10N': 'Level 10N',
  'SubAccounts_Level20N': 'Level 20N',
  'SubAccounts_Level50N': 'Level 50N',
  'SubAccounts_Level100N': 'Level 100N',
  'SubAccounts_Level200N': 'Level 200N',
  'SubAccounts_Level500N': 'Level 500N',
  'SubAccounts_Pro': 'Pro',
  'SubAccounts_Trial': 'Trial',
  'SubAccounts_Rate': 'Subscription Accounts Rate',
};

export const level = {
  10: '3N',
  12: '1N',
  15: '10N',
  20: '20N',
  25: '50N',
  30: '100N',
  40: '200N',
  41: '3A',
  45: '5'
};

export const planType = {
  'No': 0,
  'Yes': 1
};

export const planKey = {
  'Yes': 'Y',
  'No': 'N'
};

export const summaryCharType = {
  'weekly': 'weekly',
  'monthly': 'weekly'
};

export const summaryEventType = {
  'Warning': 'Warning Event',
  'Critical': 'Critical Event',
  'Utility': 'Utility Power Failed',
  'Buck': 'Enabling Buck',
  'Boost': 'Enabling Boost',
  'Overload': 'Overload',
};

export const summaryEventNumber = {
  'Warning': 1,
  'Critical': 2,
  'Utility': 0,
  'Buck': 3,
  'Boost': 2,
  'Overload': 32,
};

export const OAuthPlatformType = {
  'Apple': 0,
  'Google': 1,
  'Facebook': 2,
  'SSO': 3
};

export const OAuthPurposeType = {
  'LoginOauth': 0,
  'AddOauth': 1,
  'LoginOauthBySW': 2,
  'AddAccountFromWeb': 3,
  'AddAccountFromSW': 4
};

export const OAuthLoginMessage = {
  'ChooseEmail': -1,
  'AddAccountAvailable': 0,
  'HasAnotherPlatform': 1,
  'SameEmailExist': 2
};

export const OAuthAddErrorMessage = {
  'AlreadyBinded': 'Already Binded.',
  'AccountNotFound': 'Account not found.',
  'ValidationError': 'Validation Error.'
};

export const OAuthDeleteErrorMessage = {
  'NoCustomPassword': 'No custom password.',
};

export const fileType = {
  'RootCertificate': 'Root Certificate',
  'IntermediateCertificate': 'Intermediate Certificate',
  'WildcardCertificate': 'Wildcard Certificate',
  'PrivateKey': 'Private Key',
  'Logo': 'Logo',
};

export const containerType = {
  'Firmware' : 'firmware',
  'Region' : 'region',
};

export const ssoType = {
  'SamlCertificate' : 'Saml Certificate'
};

export const AuthOtpType = {
  'EnableOTP': 0,
  'DisableOTP': 1,
  'Login': 2,
  'CompanionEnable': 3,
  'CompanionDisable': 4,
  'CompanionCode': 5,
  'MainAppEnable' : 6,
  'MainAppDisable' : 7,
  'SMSSetting' : 8,
  'LoginSW': 9,
  'EnableAPI': 10,
  'EnableAPIKey': 12,
  'DisableAPI': 11,
  'DisableAPIKey': 13,
  'AddAPIKey': 14,
  'DeleteAPIKey': 15,
  'SoftwareUpgrade': 16,
  'EnableUpsControl': 17,
  'DisableUpsControl': 18,
  'TurnOff': 19,
  'TurnOn': 20,
  'PowerCycle': 21,
};

export const AuthOtpDeviceType = {
  'Web': 0,
  'Mobile': 1,
};

export const CheckAuthOtpErrMsg = {
  '0' : 'You entered the wrong OTP!',
  '1' : 'The OTP is no longer valid for entering because it has been submitted falsely for 5 times.',
  '2' : 'OTP is expired.',
};

export const CheckCompanionCodeErrMsg = {
  '0' : 'You entered the wrong companion code!',
  '1' : 'The companion code is no longer valid for entering because it has been submitted falsely for 5 times.',
  '2' : 'Companion code is expired.',
};

export const DeviceResetOptionType = [
  { label: 'RCCARD100', value: 2 },
  { label: 'RWCCARD100', value: 5 },
  { label: 'UPS', value: 0 },
];


export const SystemLogMessage = {
  1: {
    range: 'Account',
    action: 'Account Registration',
    message: {
      true: 'Your account was registered',
      false: 'Your account was registered failed',
    }
  },
  2: {
    range: 'Account',
    action: 'Account Activate',
    message: {
      true: 'Your account was activated',
      false: 'Your account was activated failed',
    }
  },
  3: {
    range: 'Account',
    action: 'Login',
    message: {
      true: 'Account login was successful',
      false: 'Account login failed',
    }
  },
  4: {
    range: 'Account',
    action: 'Logout',
    message: {
      true: 'Account logout',
      false: 'Account logout failed',
    }
  },
  5: {
    range: 'Account',
    action: 'Email Change',
    message: {
      true: 'Email was changed',
      false: 'Email change was failed',
    }
  },
  6: {
    range: 'Account',
    action: 'Update Mobile',
    message: {
      true: 'Your mobile was updated',
      false: 'Mobile update was failed',
    }
  },
  7: {
    range: 'Account',
    action: 'Remove Mobile',
    message: {
      true: 'Your mobile was removed',
      false: 'Remove mobile was failed',
    }
  },
  11: {
    range: 'Device',
    action: 'Add Device',
    message: {
      true: 'Device was added',
      false: 'Device add was failed',
    }
  },
  12: {
    range: 'Device',
    action: 'Delete Device',
    message: {
      true: 'Device was deleted',
      false: 'Device delete was failed',
    }
  },
  13: {
    range: 'Device',
    action: 'Share Device',
    message: {
      true: 'Device started to be shared with',
      false: 'Share Device was failed',
    }
  },
  14: {
    range: 'Device',
    action: 'Alert Setting',
    message: {
      true: 'The alert setting was successful',
      false: 'The alert setting was failed',
    }
  },
  15: {
    range: 'Device',
    action: 'Firmware Update',
    message: {
      true: 'The firmware update was successful',
      false: 'The firmware update was failed',
    }
  },
  16: {
    range: 'Device',
    action: 'Settings Change',
    message: {
      true: 'Your device setting is changed',
      false: 'Your device setting was change failed',
    }
  },
  17: {
    range: 'Device',
    action: 'Battery Test',
    message: {
      true: 'Battery test was successfully initiated',
      false: 'Battery test was failed to start',
    }
  },
  21: {
    range: 'Activate',
    action: 'Activate Plan',
    message: {
      true: 'was activated',
      false: 'was failed to be activated',
    }
  },
  22: {
    range: 'Activate',
    action: 'Activate Plan Key',
    message: {
      true: 'Plan Key was activated',
      false: 'Plan Key was failed to be activated',
    }
  },
  23: {
    range: 'Activate',
    action: 'Two-Factor Authentication',
    message: {
      true: 'Two-factor authentication was activated',
      false: 'Two-factor authentication was failed to be activated',
    }
  },
  24: {
    range: 'Activate',
    action: 'Social Account Login',
    message: {
      true: 'Social Account Login was successful',
      false: 'Social Account Login was failed',
    }
  },
  25: {
    range: 'Activate',
    action: 'Social Account Combination',
    message: {
      true: 'Social Account Combination was successful',
      false: 'Social Account Combination was failed',
    }
  },
  31: {
    range: 'Group',
    action: 'Create Order',
    message: {
      true: 'Order was created',
      false: 'Create Order was failed',
    }
  },
  32: {
    range: 'Group',
    action: 'Create Group',
    message: {
      true: 'Group was created',
      false: 'Create Group was failed',
    }
  },
  33: {
    range: 'Group',
    action: 'Delete Group',
    message: {
      true: 'Group was deleted',
      false: 'Delete Group was failed',
    }
  },
  // 34: {
  //   range: 'Group',
  //   action: 'Add to Group',
  //   message: {
  //     true: 'Device was added into Group',
  //     false: 'Add device Group was failed',
  //   }
  // },
  // 35: {
  //   range: 'Group',
  //   action: 'Remove from Group',
  //   message: {
  //     true: 'Device was deleted from Group',
  //     false: 'Delete device in Group was failed',
  //   }
  // },
  34: {
    range: 'Group',
    action: 'Update Group',
    message: {
      true: 'The Group Device update was successful',
      false: 'The Group Device update was failed',
    }
  },
  41: {
    range: 'Global Map',
    action: 'Create Site',
    message: {
      true: 'Map site was created',
      false: 'Create map site was failed',
    }
  },
  42: {
    range: 'Global Map',
    action: 'Delete Site',
    message: {
      true: 'Map site was deleted',
      false: 'Delete map site was failed',
    }
  },
  51: {
    range: 'Device Map',
    action: 'Create Map',
    message: {
      true: 'Device Map was created',
      false: 'Create device map was failed',
    }
  },
  52: {
    range: 'Device Map',
    action: 'Delete Map',
    message: {
      true: 'Device Map was deleted',
      false: 'Delete device map was failed',
    }
  },
  61: {
    range: 'Companion',
    action: 'Companion Code',
    message: {
      true: 'Update to be received via',
      false: 'Update received was failed',
    }
  },
  62: {
    range: 'Companion',
    action: 'Add Companion',
    message: {
      true: 'Companion was added',
      false: 'Add companion was failed',
    }
  },
  63: {
    range: 'Companion',
    action: 'Delete Companion',
    message: {
      true: 'Companion was deleted',
      false: 'Delete Companion was failed',
    }
  },
  64: {
    range: 'Companion',
    action: 'Enable Companion',
    message: {
      true: 'Companion was enable',
      false: 'Companion was failed to be enabled',
    }
  },
  65: {
    range: 'Companion',
    action: 'Disable Companion',
    message: {
      true: 'Companion was disable',
      false: 'Companion was failed to be disabled',
    }
  },
  66: {
    range: 'Companion',
    action: 'Update Rule',
    message: {
      true: 'Companion rule was updated',
      false: 'Update companion rule was failed',
    }
  }
};

export const CompanionStatus = {
  0 : 'Normal',
  1 : 'Shutdown',
  2 : 'Hibernation',
  3 : 'Offline',
  // 4 : 'Warning',
};

export const CompanionRuleType = {
  0 : 'Shutdown',
  1 : 'Hibernation',
};

export const CompanionEvent = {
  0 : {
    0: 'Communication with PowerPanel Cloud is normal',
    1: 'Shutdown event restored',
    2: 'Hibernating event restored',
    3: 'Shutdown process was terminated',
    4: 'Hibernating process was terminated',
    5: 'User terminated shutdown process',
    6: 'User terminated hibernating process',
  },
  1 : {
    20: 'Shutdown event was triggered',
    22: 'Shutdown process was initiated',
  },
  2 : {
    21: 'Hibernating event was triggered',
    23: 'Hibernating process was initiated',
  },
  3 : {
    30: 'Computer is offline',
  }
};

export const UpsEvents = [
  { label: 'Battery capacity is critically low', value: 113 },
  { label: 'System is overheating', value: 128 },
  { label: 'UPS Hardware Fault', value: 36 },
  { label: 'The output power is going to stop soon', value: 29 },
  { label: 'Utility power failed', value: 0 },
];

export const UpsEventsId = {
  113 : 'Battery capacity is critically low',
  128 : 'System is overheating',
  36 : 'UPS Hardware Fault',
  29 : 'The output power is going to stop soon',
  0 : 'Utility power failed',
};

export const CompaionLimit = {
  'CompaionLimit' : 'Compaion Limit',
  'CompaionRuleLimit' : 'Companion Rule Limit'
};

export const ReceiveResult = {
  0 : 'SMS',
  1 : 'PowerPanelCloudApp'
};


export const CompanionFrom = {
  'Web' : 0,
  'App' : 1
};

export const CompanionType = {
  'enableCompanion' : 'enableCompanion',
  'disableCompanion' : 'disableCompanion',
  'enableCompanionConfirm' : 'enableCompanionConfirm',
  'disableCompanionConfirm' : 'disableCompanionConfirm',
  'Confirm_CompanionEvent' : 'Confirm_CompanionEvent',
  'ResendCode' : 'ResendCode',
  'Reload_Companion' : 'Reload_Companion',
  'NotifiStatus' : 'NotifiStatus',
  'saveReceiveCompanion' : 'saveReceiveCompanion',
  'closeCompanionOTPdailog' : 'closeCompanionOTPdailog',
};

export const CompanionSendAppCount = {
  Count : 12
};

export const geteventEmitterType = {
  SelectByRegion : 'SelectByRegion',
  SelectTab : 'SelectTab'
};

export const APIType = {
  'enableAPIAccess' : 'enableAPIAccess',
  'disableAPIAccess' : 'disableAPIAccess',
  'enableAPIKey' : 'enableAPIKey',
  'disableAPIKey' : 'disableAPIKey',
  'addAPIKey' : 'addAPIKey',
  'deleteAPIKey' : 'deleteAPIKey',
  'closeAPIOTPdailog' : 'closeAPIOTPdailog',
};

export const upsControlType = {
  'enableUpsControlAccess' : 'enableUpsControlAccess',
  'disableUpsControlAccess' : 'disableUpsControlAccess',
  'closeUpsControlOTPdailog' : 'closeUpsControlOTPdailog',
  'turnOn' : 'turnOn',
  'turnOff' : 'turnOff',
  'powerCycle' : 'powerCycle',
};

export const apiKeyAuth = 'api_key_authority';

export const statusType = {
  0: 'Disable',
  1: 'Enable',
  2: 'Expired'
};

export const ChangeMemberMsgStr = {
  Account: '(Account)',
  Company: '(Company)'
};

export const CheckCompanyMemberMsg = {
  // 檢核成功
  0 : '檢核成功',
  // 確認account mail 是否存在
  1 : '"(Account)" does not exist.',
  // 己存在於其它 MSP 公司
  2 : '"(Account)" is already a member of "(Company)". Please use the Authority function to adjust the permissions directly.',
  // 此 Account 不屬於原 Region 下
  3 : '"(Account)" is not eligible to become member of "(Company)". Please contact us for further assistance.',
  // 是否輸入重複的 email
  4 : '"(Account)" is already a member of "(Company)".',
  // 確認account mail 是否有效,與member list的Domain相同
  5 : 'Email Domain must match existing member',
  // //確認account mail 是否有效,與Loacal Admin的Domain相同
  // 6 : '(Account ID) is not eligible to become member of "(Company)". Please contact us for further assistance.',
  // //mail的格式判斷
  // 7 : 'Invalid email format'
  // 新增失敗。該帳戶已經是另一個 PPC PRO 帳戶的成員。
  8 : 'Add failed. The account is already a member of another PPC PRO account.'

};

// #930 PRL1500RT2UC與PRL3000RT2UC兩種機型關閉BHI計算功能
export const hideBHIModelList = ['PRL1500RT2UC', 'PRL3000RT2UC'];

export const mspPaymentDocumentStatus = {
  0: 'Open',
  1: 'Close',
  2: 'Cancel',
  3: 'Unconfirm'
};

export const mspPaymentDocumentStatusNumber = {
  'Open': 0,
  'Close': 1,
  'Cancel': 2,
  'Unconfirm': 3
};

export const ComfirmGenerateDocumentManuallyType = {
  ComfirmAndSend: 'ComfirmAndSend',
  Send: 'Send'
};

export const DocumentTypeName = {
  0: 'PO',
  1: 'Invoice',
};

export const DefaultMinimumQuantity = {
  Count : 20
};

export const GateWayStatus = {
  0 : 'online',
  1 : 'offline'
};

export const GateWaySnmpType = {
  0 : 'Mib',
  1 : 'Trap'
};

export const GateWaySnmpProfile = {
  0 : 'SNMP V1',
  1 : 'SNMP V3'
};

export const GateWaySnmpAuthProtocol = {
  0 : 'None',
  1 : 'SHA1',
  2 : 'MD5'
};

export const GateWaySnmpPrivacyProtocol = {
  0 : 'None',
  1 : 'AES128',
  2 : 'DES'
};

export const GateWayWarningProfileStr = {
  0 : 'The gateway utilizing this profile is currently in the discovery process, and new configurations cannot be saved.'
};

export const CheckDiscoveryJobBySec = 10;
export const ReLoadDashboardSec = 60;
export const ReLoadGatewayListSec = 60; // 60秒
export const ReLoadGatewayListCount = 10; // 最多執行10次,配合60秒即為10分鐘,目前沒用到,暫時先保留
export const ReLoadDeviceUpsControlSec = 5; // 每秒執行一次

export const FirmwareType = {
  'CloudFirmware': 0,
  'RMC': 1
};

export const PurchaseType = {
  0: 'Upgrade',
  1: 'New & Renew'
};

export const errMsgForReportDiscount = {
  0: 'Maximum limit reached.',
  1: 'Ups model name is required.',
  2: 'This account cannot be a Power Panel Cloud Pro member.',
};

export const ePDUSourceMapping = {
  1: 'Source A',
  2: 'Source B',
  3: 'None'
};

export const GatewayBrand = [
    'CyberPower',
    'APC',
    'Eaton',
    'TripleLite',
    'General'
];

export const SoftwareType = {
  0: 'PPP',
  1: 'PPB',
  2: 'PPL',
  3: 'PPG'
};

export const SoftwareUpgradeStatus = {
  0: 'Started',
  1: 'Upgradting',
  2: 'Completed',
  3: 'Failed'
};

export const PrepaidUnitPrice = 2.25;
export const PrepaidMinCharge = 20;

export const ChargeType = {
  'Prepaid': 0,
  'Monthly': 1
};

export const PaymentType = {
  0: 'Prepaid',
  1: 'Monthly'
};

export const PaymentTypeIndex = {
  'Prepaid': 0,
  'Monthly': 1
};

export const PROStatus = {
  0: 'Created',
  1: 'Activated',
  2: 'Waiting',
  3: 'Locked'
};

export const PROStatusIndex = {
  'Created': 0,
  'Activated': 1,
  'Waiting': 2,
  'Locked': 3
};

export const PROLockStatus = {
  0: 'UnLocked',
  1: 'PreLocked',
  2: 'Locked'
};

export const PROLockStatusIndex = {
  'UnLocked': 0,
  'PreLocked': 1,
  'Locked': 2
};

export const PROStatusLockAuthTypeIndex = {
  'AccountManager': 0,
  'EndUserAccountManager': 1,
  'NotMspMainRegionAccountManager': 2
};

export const PROType = {
  0: 'PRO',
  1: 'Distributor',
  2: 'Customer'
};

export const PROTypeIndex = {
  'PRO': 0,
  'Distributor': 1,
  'Customer': 2
};

export const ActionType = {
  1: 'Monthly Usage',
  2: 'Sell',
  10: 'Purchase',
  11: 'Purchase',
  12: 'Purchase',
  13: 'Purchase',
};

export const ActionTypeNagetiveMapping = {
  1: -1, // Monthly Usage
  2: -1, // Sell
  11: 1, // PO
  12: 1, // Paypal
  13: 1, // Transfer
};

export const ActionTypeIndex_Sell = 2;

export const ReportDiscountPurchaseTypeIndex = {
  'update': 0,
  'new&renew': 1,
  'pro': 2
};


export const reportTypeOption = [
  { label: 'Weekly Report', value: 0 },
  { label: 'Monthly Report', value: 1 },
];

export const reportCategoryOption = [
  // { label: 'System Wellness', value: 0 },
  { label: 'Load Distribution', value: 0 },
  { label: 'UPS Protection and Power Anomaly', value: 1 },
  { label: 'Estimated Consumption', value: 2 },
];

export const reportCategory = {
  'Load Distribution' : 0,
  'UPS Protection and Power Anomaly' : 1,
  'Estimated Consumption' : 2
};

export const reportSystemWellnessOption = [
  { label: 'Critical', value: 0 },
  { label: 'Warning', value: 1 },
  { label: 'Offline', value: 2 },
];

export const reportLoadTypeOption = [
  { label: 'All', value: 0 },
  { label: 'Peak Load', value: 1 },
  { label: 'Avg. Load', value: 2 },
];

export const reportLoadDistributionOption = [
  { label: 'All', value: 0 },
  { label: 'Base', value: 1 },
  { label: 'Mid', value: 2 },
  { label: 'High', value: 3 },
];

export const SmartPowerReportBackGroundColor = {
  0: 'poor',
  1: 'average',
  2: 'good',
  3: 'excellent'
};

export const SmartPowerReportGrade = {
  1: 'A',
  2: 'B',
  3: 'C',
  4: 'D'
};

export const reportType = {
  'Weekly': 0,
  'Monthly': 1,
};

export const MailRecipientType = {
  0: 'Main Recipient',
  1: 'CC',
  2: 'BCC'
};

export const MailModuleType = {
  SmartPowerReport: 0
};

export const frequencyOption = [
  { label: 'Weekly', value: 0 },
  { label: 'Monthly', value: 1 },
];

export const weekDayOption = [
  { label: 'Sunday', value: 0 },
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
];

export const SchedulerDataType = {
  0: 'Device',
  1: 'Group'
};

// Smart Power Report Level 之後若要修改, 請統一修改此處
export const SmartPowerReportPlan = {
  level: 10,
  nodes: 10
};
